import { render, staticRenderFns } from "./ScreenTimeManagement.vue?vue&type=template&id=90b25c94&scoped=true&"
import script from "./ScreenTimeManagement.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeManagement.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTimeManagement.vue?vue&type=style&index=0&id=90b25c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b25c94",
  null
  
)

export default component.exports